import useDocumentTitle from "hooks/useDocumentTitle";
import { PageHeadingProps } from "../../types";
import Head from "view/components/Head";

const PageHeading = ({ id, name }: PageHeadingProps) => {
  return (
    <div className="flex flex-col justify-start items-start flex-grow py-0.5">
      <Head title="Home" />
      <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
        <p className="flex-grow  text-[28px] font-Overpass font-bold text-left text-textMid dark:text-textMain">
          {name}
        </p>
      </div>
    </div>
  );
};

export { PageHeading };
